import React from 'react'
import { BASE_META_DESCRIPTION } from 'app-constants'
import GenericMetaTag from 'pages/overview/component/overview-meta-tags'
import { PageWrapper } from 'pages/index-details/styled'
import { PortfolioWrapper } from './portfolio-wrapper'
import { ScopeProviderWithInitializer } from 'components/scope-provider'
import { createPortfolioStorage } from './storage'
import { zeroAddress } from 'viem'
import { useAtomValue } from 'jotai'
import { userAccountAtom } from 'context/account'

export const PortfolioContainer: React.FC = (): JSX.Element => {
  const userAddress = useAtomValue(userAccountAtom) ?? zeroAddress

  return (
    <PageWrapper>
      <ScopeProviderWithInitializer atomValues={createPortfolioStorage()} key={userAddress}>
        <GenericMetaTag
          rightHandTitle="Portfolio"
          description={BASE_META_DESCRIPTION}
          pathname="portfolio"
        />
        <PortfolioWrapper userAddress={userAddress} />
      </ScopeProviderWithInitializer>
    </PageWrapper>
  )
}
